import React from 'react';
import { Box, Typography } from '@mui/material';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import { Icons } from '../../../../assets';
import classes from './style.module.scss'

const UploadBox = () => {
  const handleDrop = (event) => {
    event.preventDefault();
    // Handle the dropped files here
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  return (
    <>
    
    <Box
      sx={{
        border: '1px dashed #8A8A8A',
        borderRadius: '8px',
        padding: '24px',
        textAlign: 'center',
        cursor: 'pointer',
        backgroundColor: '#FAFAFA',
        transition: 'background-color 0.2s ease',
        '&:hover': {
          backgroundColor: '#F1F1F1',
        },
        display: 'flex',
        gap : '16px',
        alignItems: 'center',
        justifyContent: 'center',
        height : "160px"
      }}
      onDrop={handleDrop}
      onDragOver={handleDragOver}
    >
      {/* <CloudUploadOutlinedIcon sx={{ fontSize: 40, color: '#8A8A8A' }} /> */}
      
      <img src={Icons.uploadIcon} className='w-[16px] h-[16px]'/>
      <Typography variant="subtitle1" sx={{ color: '#8A8A8A',  fontSize:'14px' ,fontWeight: "400",lineHeight: "26px",color:" #1F2155 "}} className={`${classes.typography}`}>
        Upload Files
      </Typography>
    </Box>
    </>
  );
};

export default UploadBox;
